import { Component, Input } from '@angular/core';
import { TopExpertItem } from '../../models/insights-dashboard.model';

@Component({
    selector: 'app-ask-ayen-experts',
    templateUrl: './experts-section.component.html',
    styleUrl: './experts-section.component.scss',
    standalone: false
})
export class ExpertsSectionComponent {
  @Input() experts: TopExpertItem[] = [];

  get rows() {
    return this.experts.map((item, index) => ({
      rank: index + 1,
      name: `${item.expert__first_name} ${item.expert__last_name}`.trim(),
      answeredQuestions: item.answers_count,
    }));
  }
}
